import { IQuoteSheet } from 'features/BookingFlow'
import { createContext, Dispatch } from 'react'

import { IBookingTemplate, IBookingTemplateWithLocation } from '../BookingTemplate'

type NewQuoteButtonState = {
  recentQuotes: IQuoteSheet[]
  bookingTemplates: IBookingTemplateWithLocation[]
  isLoading: boolean
  isRequestDialogOpen: boolean
  selectedTemplate: IBookingTemplate
}

type NewQuoteButtonAction =
  | { type: 'setRecentQuotes'; recentQuotes: IQuoteSheet[] }
  | { type: 'setBookingTemplates'; bookingTemplates: IBookingTemplateWithLocation[] }
  | { type: 'setIsLoading'; isLoading: boolean }
  | { type: 'openRequestDialog'; template: IBookingTemplate }
  | { type: 'closeRequestDialog' }

export const newQuoteButtonInitialState: NewQuoteButtonState = {
  recentQuotes: [],
  bookingTemplates: [],
  isLoading: false,
  isRequestDialogOpen: false,
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'IBookingTem... Remove this comment to see the full error message
  selectedTemplate: null,
}

export const newQuoteButtonReducer = (
  state: NewQuoteButtonState,
  action: NewQuoteButtonAction
): NewQuoteButtonState => {
  switch (action.type) {
    case 'setRecentQuotes':
      return { ...state, recentQuotes: action.recentQuotes }
    case 'setBookingTemplates':
      return { ...state, bookingTemplates: action.bookingTemplates }
    case 'setIsLoading':
      return { ...state, isLoading: action.isLoading }
    case 'openRequestDialog':
      return { ...state, isRequestDialogOpen: true, selectedTemplate: action.template }
    case 'closeRequestDialog':
      // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'IBookingTem... Remove this comment to see the full error message
      return { ...state, isRequestDialogOpen: false, selectedTemplate: null }
    default:
      return state
  }
}

export interface NewQuoteButtonContextProps extends NewQuoteButtonState {
  dispatch: Dispatch<NewQuoteButtonAction>
  reload: () => void
  requestQuote: (quoteSheet: IQuoteSheet) => void
}

export const NewQuoteButtonContext = createContext<Partial<NewQuoteButtonContextProps>>({})
